import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const StructureCure = ({
  width = 16,
  height = 16,
  className,
  color,
  decorative = false,
  ariaLabel = "StructureCure",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 16 16"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <g strokeWidth="0.3" clipPath="url(#clip_structure_cure)">
        <path d="M4.384 16H3.25a.25.25 0 0 1-.25-.25V.25A.25.25 0 0 1 3.25 0h1.134a.25.25 0 0 1 .25.25v15.5a.25.25 0 0 1-.25.25Zm-.884-.5h.634V.5H3.5z" />
        <path d="M6.268 6.289H4.383a.25.25 0 0 1-.25-.25V2.416a.25.25 0 0 1 .25-.25h1.885a.25.25 0 0 1 .25.25v3.623a.25.25 0 0 1-.25.25Zm-1.635-.5h1.385V2.666H4.633z" />
        <path d="M12.523 7.604h-6.25a.25.25 0 0 1-.25-.25v-6.25a.25.25 0 0 1 .25-.25h6.25a.25.25 0 0 1 .25.25v6.25a.25.25 0 0 1-.25.25Zm-6-.5h5.75v-5.75h-5.75z" />
        <path d="M9.957 6.14H8.819a.25.25 0 0 1-.25-.25v-.842h-.842a.25.25 0 0 1-.25-.25V3.661a.25.25 0 0 1 .25-.25h.842v-.843a.25.25 0 0 1 .25-.25h1.138a.25.25 0 0 1 .25.25v.843h.842a.25.25 0 0 1 .25.25v1.137a.25.25 0 0 1-.25.25h-.842v.843a.25.25 0 0 1-.25.25Zm-.888-.5h.638v-.842a.25.25 0 0 1 .25-.25h.842v-.637h-.842a.25.25 0 0 1-.25-.25v-.843h-.638v.843a.25.25 0 0 1-.25.25h-.842v.637h.842a.25.25 0 0 1 .25.25z" />
      </g>
      <defs>
        <clipPath id="clip_structure_cure">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
